module.exports = __webpack_public_path__ + "static/video-nfts-popup-b99f1e2fd9f74166ca9e74af83167c5f.png";